import type { VatId } from '@e-socna/data-layer';

import type { MappedReferencesContext } from '../../../../contexts/ReferencesContext';
import { formatAmount } from '../../../../utils/format-amount.util';
import { formatPercent } from '../../../../utils/format-percent.util';
import type { DevisPrestationsUsageAmountsRenderModel } from '../utils/build-devis-prestations-render-model.util';

interface Props {
  readonly amounts: DevisPrestationsUsageAmountsRenderModel;
  readonly currenciesIdMap: MappedReferencesContext['currenciesIdMap'];
  readonly vatsIdMap: MappedReferencesContext['vatsIdMap'];
}

export const DevisPrestationsUsageAmounts = ({
  amounts,
  currenciesIdMap,
  vatsIdMap,
}: Readonly<Props>) => {
  const vatPercentage = vatsIdMap[amounts.vatId as VatId]?.value ?? 0;

  return (
    <div>
      Prix HT : {formatAmount(amounts.priceExcludingVat, currenciesIdMap)}
      {amounts.discountPercentage ? (
        <> — Remise : {formatPercent(amounts.discountPercentage)}</>
      ) : null}
      {amounts.discountAmount ? (
        <> ({formatAmount(amounts.discountAmount, currenciesIdMap)})</>
      ) : null}
      {' — TVA : '}
      {formatPercent(vatPercentage)}
    </div>
  );
};
